import(/* webpackMode: "eager", webpackExports: ["default"] */ "/build/src/components/pages/internet-of-agents/secondary-nav.tsx");
